// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentMethodSkeleton-paymentMethodSkeletonBox-TLx8W {
  padding: 24px;
  background: var(--background-primary);
  margin-top: 6px;
  border-radius: 0 0 var(--radius-3) var(--radius-3);
}

.PaymentMethodSkeleton-paymentMethodSkeletonLabel-B7PjN {
  max-width: 131px;
  height: 26px;
  margin-bottom: 6px;
  background: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
}

.PaymentMethodSkeleton-paymentMethodSkeletonInput-CoFpZ {
  max-width: 100%;
  height: 44px;
  background: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
}

@media (max-width: 767px) {
  .PaymentMethodSkeleton-paymentMethodSkeletonBox-TLx8W {
    padding: 18px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/PaymentMethodSkeleton/PaymentMethodSkeleton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE;IACE,aAAa;EACf;;AAEF","sourcesContent":[".paymentMethodSkeletonBox {\n  padding: 24px;\n  background: var(--background-primary);\n  margin-top: 6px;\n  border-radius: 0 0 var(--radius-3) var(--radius-3);\n}\n\n.paymentMethodSkeletonLabel {\n  max-width: 131px;\n  height: 26px;\n  margin-bottom: 6px;\n  background: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n}\n\n.paymentMethodSkeletonInput {\n  max-width: 100%;\n  height: 44px;\n  background: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n}\n\n@media (max-width: 767px) {\n  .paymentMethodSkeletonBox {\n    padding: 18px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentMethodSkeletonBox": `PaymentMethodSkeleton-paymentMethodSkeletonBox-TLx8W`,
	"paymentMethodSkeletonLabel": `PaymentMethodSkeleton-paymentMethodSkeletonLabel-B7PjN`,
	"paymentMethodSkeletonInput": `PaymentMethodSkeleton-paymentMethodSkeletonInput-CoFpZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
